import { StoryCardCompact } from '@/components/server/story-card/story-card-compact'
import type { Locale } from '@/i18n'
import type { AuthorPageStory } from '@/lib/supabase/get-author-page'

export type AuthorArchiveStory = Pick<
  AuthorPageStory,
  'fullSlug' | 'imageUrl' | 'noindex' | 'publishedAt' | 'republishedAt' | 'title'
>

/**
 * The archive list's story tile. A thin wrapper over the shared
 * `StoryCardCompact` — this markup used to live here in full and had drifted
 * into a near-duplicate of two other cards on this same page.
 */
export const HistoryStoryCard = ({ story, locale }: { story: AuthorArchiveStory; locale: Locale }) => (
  <StoryCardCompact story={story} locale={locale} origin="author-history-story" tracking="ignore" />
)
